import React from 'react'

export default function RenderNorma( ficha, el, data ) {
    if (el.tipoinfracao === "1 - Estágio não obrigatório do curso de Fisioterapia em quantitativo acima do permitido na Resolução 432/2013") {
        return (
            <>
                Art. 7º da Resolução COFFITO 432/13 e Art. 9º, inciso VIII
                da Resolução COFFITO nº 424/2013 e Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "2 - Estágio obrigatório de acadêmicos(as) do curso de Fisioterapia com ausência de acompanhamento de docente da Instituição de Ensino Superior (IES)") {
        return (
            <>
                Artigos 1º e 2º da Resolução COFFITO 431/2013, art. 41, VI e Art. 9º,
                inciso VIII e art. 41 da Resolução COFFITO nº 424/2013 (Código de Ética e Deontologia do Fisioterapeuta)
                e e Art. 16 incisos I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "3 - Exercício ilegal da profissão de fisioterapeuta.") {
        return (
            <>
                Artigo 12 e Artigo 16 incisos I e VIII da Lei 6.316/75;
                Artigos 2º e 3º do Decreto-Lei 938/69; Artigo. 47 do Decreto-Lei nº 3.688
                (Lei das Contravenções Penais)
            </>
        )
    }
    else if (el.tipoinfracao === "4 - Prática de atividades da Fisioterapia por pessoa não habilitada.") {
        return (
            <>
                Artigos 2º e 3º do Decreto-Lei 938/69 e art. 47 do Decreto-Lei
                nº 3.688 ( Lei das Contravenções Penais).
            </>
        )
    }
    else if (el.tipoinfracao === "5 - Delegação de função privativa do profissional fisioterapeuta.") {
        return (
            <>
                Art. 4º da Resolução COFFITO 80/87; Art. 9º, incisos II e VIII e
                art. 25, V da Resolução COFFITO nº 424/2013 (Código de Ética e Deontologia da Fisioterapia) e
                art. 16, I, IV e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "6 - Empresa não possui a Declaração de Regularidade para Funcionamento (DRF) do serviço.") {
        return (
            <>
                Art. 5º da Resolução COFFITO Nº 037/1984.
            </>
        )
    }
    else if (el.tipoinfracao === "7 - Ausência do responsável técnico de Fisioterapia.") {
        return (
            <>
                Art. 1º da Resolução COFFITO 139/1992; Art. 9º inciso VIII e Art. 31 da
                Resolução COFFITO 424/13 (código de ética profissional de Fisioterapia) e Art. 16, incisos I e VIII da
                Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "8 - Profissional com Licença Temporária de Fisioterapia vencida.") {
        var dataLtf = `${el.vencimento.slice(8, 10)}/${el.vencimento.slice(5, 7)}/${el.vencimento.slice(0, 4)}`
        return (
            <>
                Art. 12 da Lei 6316/75, que dispõe sobre a obrigatoriedade do registro
                profissional junto ao CREFITO.
            </>
        )
    }
    else if (el.tipoinfracao === "9 - Falta de registro das atividades assistenciais fisioterapêuticas, no que tange sobre a obrigatoriedade do registro em prontuário pelo fisioterapeuta, da guarda e do seu descarte. (Responsável Técnico)") {
        return (
            <>
                O descumprimento das normas e leis vigentes no país, notadamente as
                Resoluções em questão, configura infração aos Art. 2º incisos I e III e Art. 3º da Resolução
                COFFITO Nº 139/92), que dispõe sobre as atribuições do Exercício da Responsabilidade Técnica;
                Arts. 1º e 2º da Resolução COFFITO 414/12 e Art. 16 incisos I e VII da Lei 6.316/75 e Art. 9º,
                inciso VIII da Resolução COFFITO nº 424/2013.
            </>
        )
    }
    // 930/12 Revogada
    // else if (el.tipoinfracao === "10 - Descumprimento a RDC-07.") {
    //     return (
    //         <>
    //             O descumprimento das normas e leis vigentes no país, notadamente as
    //             Resoluções em questão, configurando infração aos Arts. 2º, incisos I e III e Art. 3º da Resolução
    //             COFFITO Nº 139/92, que dispõe sobre as atribuições do Exercício da Responsabilidade Técnica.
    //             <br />
    //             - Art. 14, inciso IV da RDC Nº 07/10 da Agência Nacional de Vigilância Sanitária – ANVISA, (observar também o Artigo 13º § 2  – título de especialista do coordenador de UTI; e o Artigo 15 - fisioterapeuta disponível em tempo integral).
    //             <br />
    //             - Portaria 930/12 MS, Art. 13º- inciso VI alínea f.
    //             <br />
    //             - Art. 9º, inciso VIII da Resolução COFFITO nº 424/2013 e Art. 16, I e VIII da Lei nº 6.316/1975.
    //         </>
    //     )
    // }
    else if (el.tipoinfracao === "10 - Falta de registro de consultório.") {
        return (
            <>
                Artigo 105 da Resolução COFFITO Nº08/1978.
            </>
        )
    }
    else if (el.tipoinfracao === "11 - Débitos com obrigações pecuniárias.") {
        return (
            <>
                Art. 15 e Art. 16, incisos I e VII da Lei 6.316/75 e Art. 9º, inciso VIII da
                Resolução COFFITO nº 424/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "12 - Descumprimento dos parâmetros assistenciais fisioterapêuticos.") {
        return (
            <>
                O descumprimento das normas e leis vigentes no país, notadamente as
                Resoluções em questão, configura infração aos Artigo 2º, incisos I e III e Artigo 3º da Resolução
                COFFITO Nº 139/92, que dispõe sobre as atribuições do Exercício da Responsabilidade Técnica,
                Artigo 9º incisos VII e VIII da Resolução COFFITO 424/13 (Código de Ética e Deontologia da Fisioterapia); ao Art. 16 incisos I e VIII da
                Lei nº 6.316/1975 e Resolução COFFITO nº 444/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "13 - Descumprimento da Portaria CREFITO-1 Nº 046/2020") {
        return (
            <>
                Portaria CREFITO-1 Nº 046/2020 (Institui as diretrizes para o funcionamento dos
                serviços de Fisioterapia e de Terapia Ocupacional, na rede pública ou privada, visando evitar a
                proliferação do novo Coronavírus (Sars-CoV-2), causador da pandemia de Covid-19).
            </>
        )
    }
    else if (el.tipoinfracao === "14 - Descumprimento da legislação referente ao registro em prontuário dos fisioterapeutas.") {
        return (
            <>
                Artigos 1º e 2º da Resolução COFFITO 414/12, Artigo 16, incisos I e VII da Lei
                6.316/75 e Artigo 9º, inciso VIII da Resolução COFFITO nº 424/2013.
            </>
        )
    }
    else if (el.tipoinfracao === "15 - Publicidade irregular - exposição de pacientes.") {
        return (
            <>
                Artigo 15, inciso V da Resolução COFFITO Nº 424/13; Art. 9º, inciso VIII da
                Resolução COFFITO nº 424/2013 e Art. 16 incisos I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "16 - Publicidade irregular") {
        return (
            <>
                Art. 9º, inciso VI e VIII da Resolução COFFITO No 424/2013 e Art. 10, II,
                alínea “b” do mesmo códex e Art. 16, I e VIII da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "17 - Falta de Registro de Pessoa Jurídica junto ao CREFITO-1.") {
        return (
            <>
                Art. 1º da Resolução COFFITO Nº 037/84, que dispõe sobre o Registro de
                empresas nos Conselhos Regionais de Fisioterapia e Terapia Ocupacional e Art. 12, parágrafo
                único, da Lei nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "18 - Profissional sem registro de inscrição secundária.") {
        return (
            <>
                Art. 1º Da Resolução COFFITO Nº 433/2013 e Art. 16, VII da lei Nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "19 - Desvio de circunscrição, pois o fisioterapeuta não realizou a transferência.") {
        return (
            <>
                Arts. 84 a 86 da Resolução COFFITO Nº 08/1978 e Art. 16, VII, da lei Nº 6.316/1975.
            </>
        )
    }
    else if (el.tipoinfracao === "20 - Falta de cadastro do estabelecimento fiscalizado de Fisioterapia.") {
        return (
            <>
                Artigo 1º, inciso I, da Resolução COFFITO nº 37/1984.
            </>
        )
    }
}